<template>
  <Drawer title="搜索引擎" placement="left" :closable="false" v-model="value2" :width="drawerWidth" :mask="true">
    <SearchMainLayer ref="search_main_layer"></SearchMainLayer>
  </Drawer>
</template>
<script>
import _searhMain from '../common_engine/search_main.vue'

export default {
  name: "drawerSearch",
  data() {
    return {
      value2: false,
      drawerWidth: 700,
    }
  },
  methods: {
    showlayer(obj, w) {
      this.value2 = true
      this.drawerWidth = w
      this.$refs.search_main_layer.fliterHeader(obj);
      this.$refs.search_main_layer.setmsgpad();
    },
    closelayer() {
      this.value2 = false
    }

  },
  components: {
    'SearchMainLayer': _searhMain,
  }
}

</script>
<style>
</style>
